<template>
  <div v-if="visible" id="pkdragon-Dialog">
    <el-dialog
      v-if="visible"
      title="title"
      :append-to-body="true"
      :visible.sync="visible"
      :width="width"
      :height='height'
      :show-close="true"
      :custom-class="customClass"
      :close-on-click-modal="closeOnClickModal"
      @close="handleClose"
      @open="handleOpen"
    >
      <!-- <el-dialog v-if="visible" title="title" :append-to-body="true" :visible.sync="visible" :width="width" :top="top" :show-close="false" :custom-class="customClass" :close-on-click-modal="closeOnClickModal" @close="handleClose" @open="handleOpen"> -->
      <slot />
      <div
        v-if="$slots.footer"
        class="footer"
        :style="{ marginTop: footerTop }"
        :class="{ items: hasItems && hasFooterItems }"
      >
        <slot name="footer" />
      </div>
    </el-dialog>
    <!-- <Back v-if="visible" :max-index="visible" @click="handleClose" /> -->
  </div>
</template>

<script>
// import Back from "../Back/index";
export default {
  name: "Dialog",
  // components: { Back },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    width: {
      type: String,
      default: "615px"
    },
    height: {
      type: String,
      default: "318px"
    },
    top: {
      type: String,
      default: "111px"
    },
    customClass: {
      type: String,
      default: ""
    },
    closeOnClickModal: {
      type: Boolean,
      default: true
    },
    footerTop: {
      type: String,
      default: "44px"
    },
    hasFooterItems: {
      // hack 解决连续打开Dialog,hasItems失效的问题
      type: Boolean,
      default: true
    },
    reRender: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      //   hasItems: false
    };
  },
  computed: {
    visible: {
      get() {
        return this.show;
      },
      set() {
        return this.show;
      }
    },
    hasItems: function() {
      let footer = this.$slots.footer;
      if (footer && footer.length) {
        return footer[0].children.length > 1;
      } else {
        return false;
      }
    }
  },
  mounted() {
    document.body.appendChild(this.$el);
  },
  destroyed() {
    if (this.$el && this.$el.parentNode) {
      this.$el.parentNode.removeChild(this.$el);
    }
  },
  methods: {
    handleClose() {
      if (this.closeOnClickModal) {
        this.$emit("update:show", false);
        this.$emit("close");
      }
      this.$store.commit("setBackTop", true);
    },
    handleOpen() {
      this.$emit("open");
    }
  }
};
</script>
<style lang="scss" scoped>
/deep/ .footer > div {
  width: 100%;
  display: flex;
  justify-content: center;
}
/deep/ .footer.items > div { 
  justify-content: space-between;
}
</style>
